export default __webpack_public_path__ + "static/media/intro-course.ed0385da.svg";